import { useState } from "react";
import { ACTIVE_ROW_CSS } from "Components/Patients/EditViewPatient/Forms/DetailSection/DetailSection";
import {
  VISIT_CHAT_VIEW,
  VISIT_FEEDBACK_VIEW,
  VISIT_NOTES_VIEW,
  VISIT_ORDER_VIEW,
  VISIT_PDFS_VIEW,
} from "./ConstantsViews";

const TABLE_HEADINGS = [
  "Provider",
  "Created",
  "Status",
  "Details",
  "Actions",
];

export const TableHeading = () => {
  return TABLE_HEADINGS.map((head, index) => (
    <th
      key={index}
      scope="col"
      className="bali_hai px-6 py-3 text-left text-sm font-medium"
    >
      {head}
      {['Created', 'Details'].includes(head)
        ? <small className="ml-1">(PST)</small>
        : ''
      }
    </th>
  ))
}

export const TableBody = ({ data, onClick }) => {
  // Which row's action was used last. These actions swap the whole panel for a
  // sub-view, so on the way back there was nothing saying which visit you had
  // just been looking at.
  const [activeRow, setActiveRow] = useState(null);
  const rowCls = (index) => (index === activeRow ? ACTIVE_ROW_CSS : undefined);

  return data.map((patient, index) => (
    <>
    <tr key={index} className={rowCls(index)}>
      <td className="px-6 py-4 whitespace-nowrap sapphire">
        <div>
          <div>{patient.docName}</div>
          <div>{patient.doctorUsername}</div>
        </div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-sm sapphire">
        {patient.createdAt}
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-sm sapphire">
        {patient.status}
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-sm sapphire">
        <table className="table-auto">
          <tbody>
            <tr>
              <td className="text-sm leading-5 font-regular light_grayish_navy">State</td>
              <td><div className="ml-4">{patient.states}</div></td>
            </tr>
            <tr>
              <td className="text-sm leading-5 font-regular light_grayish_navy">Offer</td>
              <td><div className="ml-4">{patient.offerActiveMinutes}</div></td>
            </tr>
            <tr>
              <td className="text-sm leading-5 font-regular light_grayish_navy">Accepted</td>
              <td><div className="ml-4">{patient.startedAt || 'N/A'}</div></td>
            </tr>
            <tr>
              <td className="text-sm leading-5 font-regular light_grayish_navy">Wait Started</td>
              <td><div className="ml-4">{patient.waitStartedAt || 'N/A'}</div></td>
            </tr>
            <tr>
              <td className="text-sm leading-5 font-regular light_grayish_navy">Wait Ended</td>
              <td><div className="ml-4">{patient.waitEndedAt || 'N/A'}</div></td>
            </tr>
            <tr>
              <td className="text-sm leading-5 font-regular light_grayish_navy">Closed</td>
              <td><div className="ml-4">{patient.endedAt || 'N/A'}</div></td>
            </tr>
          </tbody>
        </table>
      </td>
      <td
        className="px-6 py-4 whitespace-nowrap text-sm text-blue-chill cursor-pointer"
        onClick={() => setActiveRow(index)}
      >
        <div className="mt-2 mb-2" onClick={() => onClick(patient, VISIT_ORDER_VIEW)}>
          Order
        </div>
        <div className="mt-2 mb-2" onClick={() => onClick(patient, VISIT_NOTES_VIEW)}>
          Notes
        </div>
        <div className="mt-2 mb-2" onClick={() => onClick(patient, VISIT_FEEDBACK_VIEW)}>
          Feedback
        </div>
        <div className="mt-2 mb-2" onClick={() => onClick(patient, VISIT_PDFS_VIEW)}>
          PDFs
        </div>
        <div className="mt-2 mb-2" onClick={() => onClick(patient, VISIT_CHAT_VIEW)}>
          Chat
        </div>
      </td>
    </tr>
    <tr className={rowCls(index)}>
      <td colspan="6">
        <td className="text-sm leading-5 font-regular light_grayish_navy p-2">Last Message:</td>
        <td><div className="text-sm">{patient.lastMessage || ''}</div></td>
      </td>
    </tr>
    </>
  ));
};
